import {CALL_CONFIRMED} from 'src/pages/scheduleCallback/constants/views';
import {selectTimeslotStep} from 'src/pages/scheduleCallback/store/actions/selectTimeslotStep';
import {
  hasAppointment,
  intent,
  timeslot,
} from 'src/pages/scheduleCallback/store/selectors/app';
import {fragment} from 'src/pages/scheduleCallback/utils';
import {changeView} from 'src/shared/currentView/actions';
import {logScreenName} from 'src/shared/dataLayer/loggers';
import {pushHistory} from 'src/shared/history/actions';

export const appointmentConfirmationStep = () => (dispatch, getState) => {
  if (!hasAppointment(getState())) {
    return dispatch(selectTimeslotStep());
  }
  dispatch(pushHistory(appointmentConfirmationStep(), fragment('confirm')));
  dispatch(changeView(CALL_CONFIRMED));
  logScreenName(`${timeslot(getState()) === 'IMMEDIATE' ? 'immediateconfirm' : 'scheduledconfirm'}|${intent(getState())}`);
};
